import React from 'react'
import Plot from 'react-plotly.js'

import { GraphProps } from './Graph.types'
import { StyledPlot } from './Graph.styles'

export const hovertemplate = (
  traceName: string,
  xAxisName: string,
  yAxisName: string
) =>
  `   <b>${traceName}</b><br>` +
  `   <b>${xAxisName}:  </b>%{x}<br>` +
  `   <b>${yAxisName}:  </b>%{y}<br><br>` +
  '<extra></extra>'

export const Graph: React.FC<GraphProps> = ({
  onHover,
  onUnhover,
  onClick,
  revision,
  responsive = true,
  data,
  config,
  layout,
  className,
}: GraphProps) => {
  const defaultConfig = {
    displaylogo: false,
    responsive: true,
  }

  const styles = {
    plotBackgroundColor: '#fff',
    lineColor: '#E7E7E7',
    fontColor: '#000',
    hoverBorderColor: '#000',
    hoverBackgroundColor: '#FFF',
  }

  const properties = React.useMemo<any>(() => {
    return {
      data: data,
      layout: {
        hovermode: 'closest',
        hoverlabel: {
          bordercolor: styles.hoverBorderColor,
          bgcolor: styles.hoverBackgroundColor,
          font: { color: styles.fontColor, family: 'proxima-nova' },
          style: {
            padding: '20px',
          },
        },
        margin: {
          l: 50,
          r: 50,
          b: 50,
          t: 50,
        },
        padding: {
          l: 50,
        },
        plotBackground: styles.plotBackgroundColor,
        ...layout,
        xaxis: {
          showgrid: false,
          nticks: 8,
          showline: true,
          linewidth: 1,
          linecolor: styles.lineColor,
          title: {
            font: {
              family: 'proxima-nova',
              size: 16,
              color: styles.fontColor,
            },
          },
          tickfont: {
            family: 'proxima-nova',
            size: 14,
            color: styles.fontColor,
          },

          ...layout?.xaxis,
        },
        yaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          linewidth: 1,
          linecolor: styles.lineColor,
          nticks: 6,
          tickfont: {
            family: 'proxima-nova',
            size: 14,
            color: styles.fontColor,
          },
          ...layout?.yaxis,
        },
        showlegend: true,
      },
      config: {
        ...defaultConfig,
        ...config,
      },
    }
  }, [data])

  return (
    <StyledPlot className={className}>
      <Plot
        data={properties.data}
        config={properties.config}
        layout={properties.layout}
        useResizeHandler={responsive}
        onHover={onHover}
        onClick={(event) => onClick && onClick(event)}
        onUnhover={onUnhover}
        revision={revision}
        style={{ width: '100%', height: '100%' }}
      />
    </StyledPlot>
  )
}
